import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";
import curvedBanner from "../assect/images/bg/dl_curvedimgs_contact.png";

import Footer from "../components/footer";

import AvailableProperties from "../components/availableproperties";
export default function ContactUs() {
    return (
        <div style={{backgroundColor: "#f0eadd"}}>
            <Navbar navClass="defaultscroll sticky" menuClass="navigation-menu nav-right"/>
            <div className="top-half top-half d-table w-100" style={{paddingTop: "74px"}}>
                <section className="bg-half-116" style={{backgroundImage: `url(${curvedBanner})`}}>
                </section>
            </div>

            <section className="section-50 pb-0 mb-60">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <p className="mb-5" style={{
                                textAlign: "center",
                                fontSize: "30pt",
                                color: "#093b38",
                                fontFamily: "Bacasime Antique"
                            }}>Contact Us</p>
                            <div className="p-5 rounded-3 "
                                 style={{backgroundColor: "#FFF", borderColor: "#b65741", borderStyle: "solid"}}>
                                <form style={{backgroundColor: "#FFF"}}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <input name="name" id="name" type="text" className="form-control"
                                                       placeholder="Name :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input name="email" id="email" type="email" className="form-control"
                                                       placeholder="Email :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <input name="phone" id="phone" type="phone" className="form-control"
                                                       placeholder="Phone :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className="mb-3">
                                                <input name="stayFrom" id="stayFrom" className="form-control"
                                                       placeholder="Move-in Date :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <input name="stayTo" id="stayTo" className="form-control"
                                                       placeholder="Move-out Date :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-3">
                                                <input name="noBdrms" id="noBdrms" className="form-control"
                                                       placeholder="Number of Bedrooms :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-3">
                                                <input name="subject" id="subject" className="form-control"
                                                       placeholder="Subject :"
                                                       style={{borderColor: "lt-grey", borderWidth: ".5px"}}/>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="mb-3">
                                                <textarea name="comments" id="comments" rows="4"
                                                          className="form-control" placeholder="Message :" style={{
                                                    borderColor: "lt-grey",
                                                    borderWidth: ".5px"
                                                }}></textarea>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-4"></div>
                                        <div className="col-4">
                                            <div className="d-grid">
                                                <button type="submit" id="submit" name="send"
                                                        className="btn btn-primary orange-button">Send Message
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="d-grid">
                                                <p className="mt-3" style={{textAlign: "center", fontSize: "14px"}}>We
                                                    will respond to your inquiry within a few hours.</p>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative mt-5 pt-4">
                <div className="container-no-right-hand-padding">
                    <div className="row g-4">
                        <div className="col-lg-1"></div>
                        <div className="col-lg-10 col-md-7 col-12 mb-60 mt-60">
                            <div className="row g-4 mt-0">
                                <AvailableProperties/>
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                    </div>
                </div>
            </section>
            <Footer/>
        </div>
    )
}
